import React from 'react';
import { Container } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getXraySuccess, getXray, getXrayFailure } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    armscan : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Arm Scan'
    },
    legscan : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Leg Scan'
    },
    
}

class Hrpqct extends React.Component {

    componentDidMount() {
        this.props.getHrpqctEdit(serverUrls.hrpqct + this.props.id + '/');
    }

    render() {
        var url = serverUrls.hrpqct + this.props.id + '/';
        return (
            <Container style={{maxWidth: 800, background: colors.lightGrey}}>
                <br/>
                <h4>HR -pQCT</h4>
                <br/>
                <CreateFormInput isPost={false} buttonName="Save" url={url} formName="getXray" inputs={formInputs}/>
                <br/>
                <br/>
            </Container>
        )
    }
}

const mapStateToProps = state => {
    return {
        
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getHrpqctEdit: (url) => {
            dispatch(getXray({ loading: true }));
            axios.get(url)
                .then((res) => {
                    dispatch(getXraySuccess({ loading: false, success: res.data.success, data: res.data }));
                })
                .catch((err) => {
                    dispatch(getXrayFailure({ loading: false }));
                });
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Hrpqct);